import React from 'react';
import { Headset, BadgeCheck } from 'lucide-react';
import 'aos/dist/aos.css';
import img1 from '../../assets/images/high-angle-hand-spraying-powder-paint-vehicle.jpg'; // Replace with actual image paths
import img2 from '../../assets/images/service-worker-painting-car-auto-service.jpg'; // Replace with actual image paths
import video1 from '../../assets/Videos/5416669_Coll_wavebreak_People_3840x2160.mp4'; // Replace with actual video path

const AboutUs = () => {
  return (
    <section
      className="py-20 px-6 md:px-10"
      style={{ backgroundColor: "#F1F0EA", color: "#534B52" }}
    >
      <div className="max-w-6xl mx-auto text-center">
        {/* Centered Video */}
        <div data-aos="fade-up" className="mb-10 flex justify-center">
          <video
            src={video1}
            autoPlay
            muted
            loop
            playsInline
            className="rounded-lg shadow-xl w-full h-auto max-w-[1000px]"
          />
        </div>

        {/* Section Title */}
        <div data-aos="fade-up" className="mb-12">
          <h2 className="text-4xl font-bold mb-4" style={{ color: "#474448" }}>
            Liquid Spray Painting
          </h2>
          <p className="text-xl" style={{ color: "#534B52" }}>
            Pioneers in Liquid Spray Painting and CED Coating Solutions
          </p>
        </div>

        {/* Company Overview */}
        <div data-aos="fade-up" className="mb-16 text-lg leading-relaxed">
          <p>
            We specialize in delivering premium liquid spray painting solutions
            for commercial and industrial needs. Our modern, fast, and efficient
            spray painting services ensure excellent coverage and long-lasting
            durability on various surfaces.
          </p>
        </div>

        {/* Two Images Below */}
        <div data-aos="fade-up" className="flex flex-col md:flex-row gap-6 justify-center items-center">
          <img
            src={img1}
            alt="Liquid Spray Sample 1"
            className="w-full md:w-1/2 rounded-lg shadow-lg object-cover"
          />
          <img
            src={img2}
            alt="Liquid Spray Sample 2"
            className="w-full md:w-1/2 rounded-lg shadow-lg object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
